// Components
import { components } from "./components";

// Pages
import { pages } from "./pages";

// Blocks
import { blocks } from "./blocks";

// Partials
import { partials } from "./partials";

export const grindexModules = [...components, ...pages, ...blocks, ...partials];
